import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Response, SummaryRequest } from '../../../_shared/models';
import { AccountDateFilterRequest } from '../../../_shared/models/account-date-filter-request.model';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { OverviewSummary } from '../models/overview-summary.model';
import { OverviewTimeSeries } from '../models/overview-timeseries.model';

@Injectable({
  providedIn: 'root'
})
export class DriverOverviewService {

  constructor(private http: HttpClient) { }

  public getDriverTripSummary(request: SummaryRequest, cancellation: Subject<void>): Promise<Response<OverviewSummary>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/driver-trips-summary`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverTripTimeSeries(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OverviewTimeSeries[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/driver-trips-time-series`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverDistanceSummary(request: SummaryRequest, cancellation: Subject<void>): Promise<Response<OverviewSummary>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/driver-distance-summary`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverDistanceTimeSeries(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OverviewTimeSeries[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/driver-distance-time-series`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverPerformanceSummary(request: SummaryRequest, cancellation: Subject<void>): Promise<Response<OverviewSummary>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/driver-performance-summary`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverPerformanceTimeSeries(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OverviewTimeSeries[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/driver-performance-time-series`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverOvertimeSummary(request: SummaryRequest, cancellation: Subject<void>): Promise<Response<OverviewSummary>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/driver-overtime-cost-summary`, request).pipe(takeUntil(cancellation)));
  }

  public getDriverOvertimeTimeSeries(request: AccountDateFilterRequest, cancellation: Subject<void>): Promise<Response<OverviewTimeSeries[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driveroverview/driver-overtime-cost-time-series`, request).pipe(takeUntil(cancellation)));
  }
}
